import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import './App.css';
import Header from './components/Header';
import Chat from './components/Chat';
import ParentView from './components/ParentView';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="app">
          <Header />
          <Routes>
            <Route path="/" element={<Chat />} />
            <Route path="/parent" element={<ParentView />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;

